import { useContext } from 'react';
import { WebsiteContext } from "../utils/WebsiteContext";
export const useWebsite = () => {
    return useContext(WebsiteContext);
};
//# sourceMappingURL=useWebsite.js.map